// src/store/thunks/sixDetail/fetchFilesThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { mapSixFilesApiResponseToFileEntries } from '@/store/mappers/mapSixDetail';
import { syncFilesFromApiThunk } from '@/store/thunks/sixDetail/syncFilesFromApiThunk';

export const fetchFilesThunk = createAppAsyncThunk(
  'sixDetail/fetchFiles',
  async(params: { sixId: string }, { dispatch, extra, getState }) => {
    const rootState = getState();
    const { activeFilters, search, sortKey, sortDir } = rootState.sixDetail;

    const filesResponse = await extra.sixDetailService.fetchFiles(params.sixId, {
      filters: activeFilters,
      search,
      sortKey,
      sortDir,
    });

    const files = mapSixFilesApiResponseToFileEntries(filesResponse);
    void dispatch(syncFilesFromApiThunk({ sixId: params.sixId, files }));
    return files;
  },
);
